jQuery.noConflict();
(function( $ ) {
    $(function() {
        if ($('.sc-user-form').length >0) {
           // $('.sc-user-form input.datepicker').datepicker();

            if ($('.sc-user-form input.datepicker').length> 0) {
                $.each($('.sc-user-form input.datepicker'), function(){
                    var params = {dateFormat: 'dd/mm/yy', changeMonth: true,changeYear: true};
                    if ($(this).attr('id') == 'dob_field') {
                        params.maxDate = '-1825';
                        params.yearRange = 'c-70:c+0';
                    }
                    $(this).datepicker(params);
                });
            }

            $('.sc-user-form').on('submit', function(e){
                e.preventDefault();
                var fromID = $(this).attr('id'),
                    fields = $(this).serialize();
                $('#'+fromID+' .field-wrap').removeClass('alert');
                $('#'+fromID+' .form-validation-msg').removeClass('alert');
                $('#'+fromID+' .form-validation-msg').removeClass('ok');
                $('#'+fromID+' button[type=submit]').prop('disabled', true);
                $('#'+fromID+' .validation-error').text('');
                $('#'+fromID+' .form-validation-msg').text('');
                scUserRegSubmit(fields).then(function(data){
                    var response = decodeJSON(data);
                    $('#'+fromID+' button[type=submit]').prop('disabled', false);
                    $('#'+fromID+' .form-validation-msg').addClass(response.status).text(response.message);
                    if (response.status == 'ok') {
                        $('#'+fromID+' button[type=submit]').prop('disabled', true);

                        $('#login #username').val($('#sc_user_form_register #user_login').val());
                        $('#login #password').val($('#sc_user_form_register #passw1').val());
                        setTimeout( function(){
                            $('a.login-trigger').trigger('click');
                        }, 2000);
                    }
                    var errs = response.errors;
                    $.each(errs, function(id, txt){
                        $('#field_wrap_'+id).addClass('alert');
                        $('#validation_error_'+id).text(txt);
                    });
                });
            });
        }

        function scUserRegSubmit(fields) {
            return new Promise( function(resolve, reject) {
                $.ajax({
                    url: ajax_url,
                    type: 'GET',
                    data: ({
                        action:'sc_reg_submit',
                        fields: fields
                    }),
                    success: function (data) {
                        resolve(data)
                    },
                    error: function (error) {
                        reject(error)
                    },
                })
            })
        }

        if ($('.type_teachers_code .teachers_code_input').length> 0) {
            var teachers_code = $('#teachers_code').val();
            if (teachers_code != '' && teachers_code.length> 5) {
                $('.button.validate').show();
            }
            $('#iam').on('change', function(){
                $('#field_wrap_teachers_code .school-search').hide();
                $('#teachers_code').hide();
                var value = $(this).val();
                if (value == 'teacher') {
                    $('#field_wrap_teachers_code .school-search').show();
                    $('#teachers_code').hide();
                    if ($('.add-new-sch').length> 0) {
                        $('.add-new-sch').show();
                        $('#teachers_code').hide();
                        $('.no-code').addClass('has-hint');
                    }
                //    $('#teachers_code').show();
                }
                else if (value == 'student') {
                    $('#teachers_code').show();
                    $('.no-code').addClass('has-hint');
                    $('#field_wrap_teachers_code .school-search').hide();
                    if ($('.add-new-sch').length> 0) {
                        $('.add-new-sch').hide();
                        $('#teachers_code').show();
                    }
                }
                else {
                    $('#teachers_code').hide();
                    $('.no-code').removeClass('has-hint');
                    $('#field_wrap_teachers_code .school-search').hide();
                }
                var teachers_code = $('#teachers_code').val();
                if (teachers_code != '' && teachers_code.length> 5) {
                    $('.button.validate').show();
                }
                $('.select-sch-teacher').html('');
                $('#selected-teachers_code').html('').removeClass('ok');
                $('#school-select-teachers_code').html('').removeClass('ok');
            });

            $('.teachers_code_input').on('change keydown propertychange input', function(e){
                var value = $(this).val();
                if (value != '' && value != undefined) {
                    var letters = value.length;
                    if (letters > 4) {
                        $(this).parent().find('.button.validate').show();
                    }
                    else {
                        $(this).parent().find('.button.validate').hide();
                    }
                }
            });

            $('.school-search button').on('click', function(e){
                e.preventDefault();
                doSchoolSearch();
            });

            $(document).on("keypress", "input", function(e){
                if(e.which == 13){
                    var inputVal = $(this).val(),
                        name = $(this).attr('name');
                    if (name == 'search_school') {
                        e.preventDefault();
                        doSchoolSearch();
                    }
                }
            });

            $('.type_teachers_code .button.validate').on('click', function(e){
                e.preventDefault();
                var fields = {};
                fields['id'] = $(this).parent().find('.teachers_code_input').attr('id');
                fields['code'] = $(this).parent().find('.teachers_code_input').val();
                fields['iam'] = $('#iam').val();
                fields['teacher_school'] = $('#teacher_school').val();
                $('#select-sch-teacher').html('');
                validateTeachersCode(fields).then(function(data){
                    var response = decodeJSON(data);
                    $('#selected-'+fields['id']).text(response.msg).removeClass('validating');
                    if (response.status == 0) {
                        $('#selected-'+fields['id']).addClass('alert');
                        ('#sch_id_teachers_code').val('').trigger('change');
                    }
                    else {
                        $('#selected-'+fields['id']).addClass('ok');
                        $('#sch_id_teachers_code').val(response.school_id).trigger('change');
                    }

                    if (response.teacher_select != undefined && response.teacher_select != '') {
                        $('#select-sch-teacher').html(response.teacher_select);
                    }
                });
            });
        }

        function doSchoolSearch(){
            if ($('#search_school').length> 0) {
                var search = $('#search_school').val();
                if (search.length>2) {
                    $('#teachers_code').hide();
                    schoolSearch(search).then(function(data){
                        var response = decodeJSON(data);
                        $('#selected-teachers_code').html('').removeClass('ok alert');
                        $('#school-select-teachers_code').html(response.html).show();
                        if (response.found == 1) {
                            $('#teachers_code').show();
                        }
                        $('#add-new-sch').html(response.new);
                        if (response.found != 0) {
                            $('#teachers_code').show();
                            if ($('#teachers_code').val() != '') {
                                $('.button.validate').show();
                            }
                        }
                    });
                }
            }
        }

        function schoolSearch(search) {
            $('#school-select-teachers_code').hide();
            return new Promise( function(resolve, reject) {
                $.ajax({
                    url: ajax_url,
                    type: 'POST',
                    data: ({
                        action:'search_school',
                        search: search
                    }),
                    success: function (data) {
                        resolve(data)
                    },
                    error: function (error) {
                        reject(error)
                    },
                })
            })
        }

        function validateTeachersCode(fields) {
            $('#selected-'+fields['id']).text('Validating code').addClass('validating').removeClass('alert ok');
            return new Promise( function(resolve, reject) {
                $.ajax({
                    url: ajax_url,
                    type: 'POST',
                    data: ({
                        action:'sc_validate_teachers_code',
                        fields: fields
                    }),
                    success: function (data) {
                        resolve(data)
                    },
                    error: function (error) {
                        reject(error)
                    },
                })
            })
        }

        $('body').on('click', '.add-school-submit', function(e){
            e.preventDefault();
            var fields = {};
            $('#add-school input').each(function(){
                var name = $(this).attr('name'),
                    value = $(this).val();
                fields[name] = value;
            });
            $('#add-school select').each(function(){
                var name = $(this).attr('name'),
                    value = $(this).val();
                fields[name] = value;
            });
            $('#add-school textarea').each(function(){
                var name = $(this).attr('name'),
                    value = $(this).val();
                fields[name] = value;
            });
            addNewSchool(fields).then(function(data){
                var response = decodeJSON(data);
                $('.button.add-school-submit').prop('disabled', false);
                  if (response.errors.length> 0) {
                      var html = '<ul class="errors">';
                      $.each(response.errors, function(k,v){
                          html += '<li>'+v+'</li>';
                      });
                      html += '</ul>';
                      $('#add-school-validation').html(html);
                  }
                  else {
                      $('#add-school-validation').html(response.html);
                      $('#add-school input').remove();
                      $('#add-school select').remove();
                      $('.add-school-submit').remove();
                      $('#school-select-teachers_code').html(response.teacher_school);
                      $('#teachers_code').val(response.teacher_code).trigger('change').show();
                      $('#sch_id_teachers_code').val(response.school_id).trigger('change');
                  }

            });
        });

        function addNewSchool(fields) {
            $('.button.add-school-submit').prop('disabled', true);
            $('.add-school-validation').text('').removeClass('alert ok');
            return new Promise( function(resolve, reject) {
                $.ajax({
                    url: ajax_url,
                    type: 'POST',
                    data: ({
                        action:'sc_new_school',
                        fields: fields
                    }),
                    success: function (data) {
                        resolve(data)
                    },
                    error: function (error) {
                        reject(error)
                    },
                })
            })
        }

        $('.st-options .st-action').on('click', function(e){
            e.preventDefault();
            var action = $(this).attr('data-action'),
                studentId = $(this).attr('data-uid'),
                teacherId = $(this).attr('data-teacher');
            if (action != undefined && action != '' && studentId != undefined && studentId != '') {
                var studentName = $('#student-'+studentId+ ' > strong').text();
                if (studentName != undefined && studentName != '') {
                    var confirmMessage = 'Please confirm ['+action+'] for '+studentName;
                    if (confirm(confirmMessage) == true) {
                        console.log(studentName + ' => '+action+' : '+studentId);
                        changeSchoolStudent(action, studentId, teacherId);
                    } else {
                    }
                }
            }
        });

        function changeSchoolStudent(toDo, studentId, teacherId) {
            $.ajax({
                url: ajax_url,
                type: 'POST',
                data: ({
                    action:'sc_student_status_change',
                    toDo: toDo,
                    studentId: studentId,
                    teacherId: teacherId
                }),
                beforeSend: function() {
                },
                success: function( data ) {
                    window.location.reload();
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            })
        }

        $('span.no-code').on('click', function(e){
            e.preventDefault();
            var base = $(this).attr('data-msg');
            if (base != undefined && base != '') {
                var msg = atob(base);
                $.fancybox.open(msg, {baseClass: 'info-box'});
            }
        });

        $('body').on('click', '.request-tcode', function(e){
            e.preventDefault();
            var select = $('#teacher_school option:selected').val(),
                text = $('#teacher_school option:selected').text();
            if (select != undefined && select != '' && text != undefined && text != '') {
                var html = '';
                html += '<div class="rq-tcode-wrap"><h5>'+text+'</h5>';
                html += '<p>Good news! Your school has already been setup. Please enter your school email address to request a verification code from the master user. The code will be emailed to you directly.</p>';
                html += '<form id="rq-tcode"><input type="hidden" value="'+select+'" name="rq-tcode-id">';
                html += '<input type="email" name="you-email" placeholder="Your Email address" required>';
                html += '<button type="submit" class="button">Request Teachers Code</button>';
                html += '</form>';
                html += '<div id="rq-tcode-status"></div></div>';
                html += '';
                html += '';
                html += '';
                html += '</div>';
                $.fancybox.open(html, {baseClass: 'info-box'});
                $('.info-box')
            }
        });

        $('body').on('submit', '#rq-tcode', function(e){
            e.preventDefault();
            var email = $('#rq-tcode input[name=you-email]').val(),
                id = $('#rq-tcode input[name=rq-tcode-id]').val();
            if (email != undefined && email != '' && id != undefined && id != '') {
                console.log('eml => '+email+', id => ' +id);
                requestTeacherCode(id, email);
            }
        });

        function requestTeacherCode(id, email) {
            $('#rq-tcode button[type=submit]').prop('disabled', true);
            $('#rq-tcode-status').html('Doing Request for Teachers code');
            $.ajax({
                url: ajax_url,
                type: 'POST',
                data: ({
                    action:'teacher_code_request',
                    id: id,
                    email: email
                }),
                beforeSend: function() {
                },
                success: function( data ) {
                    $('#rq-tcode button[type=submit]').prop('disabled', false);
                    var answ = decodeJSON(data);
                    $('#rq-tcode-status').html(answ.msg);
                    if (answ.status == 'success') {
                        $('#rq-tcode button[type=submit]').prop('disabled', true);
                        $('#user_email').val(email);
                    }
                    else {

                    }
                    console.log(answ);
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            })
        }


    });
})(jQuery);